// Axios
import Axios from "./axios";

export const deleteWorkshopTestimonial = (testimonialId) => {
  return new Promise((resolve, reject) => {
    const data = Axios.delete(`/workshopTestimonial/delete/${testimonialId}`, {
      headers: {
        "access-token": localStorage.getItem("access_token"),
      },
    });
    resolve(data);
  });
};
